import './App.css';
import LoginPage from "./LoginPage/LoginPage";
import {Navigate, Route, Routes, useParams} from "react-router-dom";
import Navigation from "./Navigation/Navigation.tsx";
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from "react";
import BuildingPage from "./Pages/BuildingDetails/BuildingPage";
import MapOverview from "./MapOverview/MapOverview";
import EkonomiPage from "./Pages/Ekonomi/EkonomiPage";
import ProtectedRoute from "./ProtectedRoute";
import { onAuthStateChanged } from "firebase/auth";
import NotFoundPage from "./Pages/NotFoundPage";
import ForvaltningPage from "./Pages/Förvaltning/ForvaltningPage";
import TimelinePage from "./Pages/Timeline/TimelinePage";
import ProjectsPage from "./Pages/Projects/ProjectsPage";
import AnalysisPage from "./Pages/Analysis/AnalysisPage";
import RoomPage from "./Pages/Room/RoomPage";
import DocumentsPage from "./Pages/Documents/DocumentsPage";
import ComponentPage from "./Pages/ComponentPage/ComponentPage";
import BuildingImagesList from "./Pages/BuildingDetails/BuildingImagesList";
import EditBuildingImages from "./Pages/BuildingDetails/EditBuildingImages";
import LevelPage from "./Pages/Level/LevelPage";
import ContactsEditPage from "./Pages/ContactBook/ContactsEditPage";
import {HelmetProvider} from "react-helmet-async";
import GenericComponentListPage from "./Pages/BuildingDetails/GenericComponentListPage";
import WindowsListPage from "./Pages/BuildingDetails/WindowsListPage";
import SheetMetalListPage from "./Pages/BuildingDetails/SheetMetalListPage";
import {BaseType} from "./types/Enums";
import {BuildingProvider} from "./Helpers/BuildingContext";
import {auth} from "./firebase";
import PermitsPage from "./Pages/Permits/PermitsPage";

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import MaintenanceTemplatesEditor from "./Pages/Förvaltning/TemplatesEditor/MaintenanceTemplatesEditor";
import MaintenanceDraft from "./Pages/Förvaltning/MaintenanceDraft/MaintenanceDraft";
import MaintenancePreview from "./Pages/Förvaltning/MaintenancePreview/MaintenancePreview";
import MaintenanceReview from "./Pages/Förvaltning/MaintenanceReview/MaintenanceReview";
import MaintenanceStart from "./Pages/Förvaltning/MaintenanceStart/MaintenanceStart";
import MaintenanceActive from "./Pages/Förvaltning/MaintenanceActive/MaintenanceActive";
import SettingsPage from "./Pages/Settings/SettingsPage";
import BuildingChecksPage from "./Pages/BuildingChecks/BuildingChecksPage";
import AllBuildingChecksPage from "./Pages/BuildingChecks/AllBuildingChecksPage";
import ProfileSettings from "./Pages/ProfileSettings";

function App() {

    useEffect(() => {
        document.title = "Molnfastigheter";

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                //console.log('Signed in');
            } else {
                //console.log('Signed out');
            }
        });

        return () => unsubscribe();

    });

    const RedirectToBuilding = () => {
        const { id } = useParams();
        return <Navigate to={`/building/${id}`} replace />;
    };

    function OutdoorRedirect() {
        const { id } = useParams();
        return <Navigate to={`/building/${id}`} replace />;
      }

    return (
        <HelmetProvider>
            <div className="App">
                <header className="App-header">
                    <BuildingProvider>
                        <Routes>

                            <Route path="/" element={<LoginPage />} />
                            <Route path="/home" element={<LoginPage />} />
                            <Route path="/signIn" element={<LoginPage />} />

                            <Route
                                path="/"
                                element={
                                    <ProtectedRoute>
                                        <Navigation />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<MapOverview />} />
                                <Route path="map" element={<MapOverview />} />
                                <Route path="economy" element={<EkonomiPage />} />
                                <Route path="management" element={<ForvaltningPage />} />
                                <Route path="timeline" element={<TimelinePage />} />
                                <Route path="projects" element={<ProjectsPage />} />
                                <Route path="analysis" element={<AnalysisPage />} />
                                <Route path="building/:id" element={<BuildingPage />} />
                                <Route path="building/:id/outdoor" element={<OutdoorRedirect />} />
                                <Route path="/building/:id/roof" element={<GenericComponentListPage type={BaseType.Roof}/>} />
                                <Route path="/building/:id/facade" element={<GenericComponentListPage type={BaseType.Facade}/>} />
                                <Route path="/building/:id/foundation" element={<GenericComponentListPage type={BaseType.Foundation}/>} />
                                <Route path="/building/:id/chimney" element={<GenericComponentListPage type={BaseType.Chimney}/>} />
                                <Route path="/building/:id/roof_drainage" element={<GenericComponentListPage type={BaseType.RoofDrainage}/>} />
                                <Route path="/building/:id/ground_drainage" element={<GenericComponentListPage type={BaseType.GroundDrainage}/>} />
                                <Route path="/building/:id/windows" element={<WindowsListPage />} />
                                <Route path="/building/:id/sheet-metal" element={<SheetMetalListPage />} />
                                <Route path="/building/:id/documents" element={
                                    <DocumentsPage
                                        title="Dokument & anteckningar"
                                        fileTypeOptions={[
                                            { value: "document", label: "Dokument" },
                                            { value: "blueprint", label: "Ritningar" },
                                            { value: "expert_assessment", label: "Expertutredningar" },
                                            { value: "shore_protection", label: "Strandskydd" },
                                            { value: "building_permits", label: "Bygglov" },
                                        ]}
                                    />
                                }/>
                                <Route path="/building/:id/room/:roomId" element={<RoomPage />} />
                                <Route path="/building/:id/room" element={<RedirectToBuilding />} />
                                <Route path="/building/:id/level/:levelId" element={<LevelPage />} />
                                <Route path="/building/:id/level" element={<RedirectToBuilding />} />
                                <Route path="/building/:buildingKey/component/:itemId" element={<ComponentPage />} />
                                <Route path="/building/:id/allPhotos" element={<BuildingImagesList />} />
                                <Route path="/building/:id/editImages" element={<EditBuildingImages />} />
                                <Route path="/building/:id/editContacts" element={<ContactsEditPage />} />
                                <Route path="/building/:id/permits" element={<PermitsPage />} />
                                <Route path="/building/:id/checks" element={<BuildingChecksPage />} />
                                <Route path="/building-checks" element={<AllBuildingChecksPage />} />
                                <Route path="/maintenance" element={<MaintenanceStart />} />
                                <Route path="/maintenanceTemplates" element={<MaintenanceTemplatesEditor />} />
                                <Route path="/maintenanceDrafts/:buildingKey" element={<MaintenanceDraft />} />
                                <Route path="/maintenancePreview/:buildingKey" element={<MaintenancePreview />} />
                                <Route path="/maintenanceReview/:buildingKey" element={<MaintenanceReview />} />
                                <Route path="/maintenanceActive/:buildingKey" element={<MaintenanceActive />} />
                                <Route path="settings" element={<SettingsPage />} />
                                <Route path="profile" element={<ProfileSettings />} />
                                <Route path="*" element={<NotFoundPage />} />

                            </Route>

                        </Routes>
                    </BuildingProvider>
                </header>
            </div>
        </HelmetProvider>
    );
}

export default App;
